export default __webpack_public_path__ + "static/media/1025.0593588c.svg";